
































import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

export enum ViewType {
  List,
  Chart
}

export default mixins(Proxyable).extend({
  name: 'EmployeeViewSelector',

  data() {
    return {
      ViewType
    };
  }
});
